// Dashboard.jsx - FIXED VERSION
import React from "react";
import "../Dashboard/Dashboard.css";
import { useDashboardData } from "../useDashboardData";
import SummaryCards from "../../components/SummaryCards";
import TopAppsPieChart from "../../components/TopAppsPieChart";
import MembersLiveChart from "../../components/MembersLiveChart";
import TeamActivityTable from "../TeamActivityTable";
import ScreenshotsGallery from "../../components/ScreenshotsGallery";
import ProductivityTrendChart from "../../components/ProductivityTrendChart";
import TimeTrackingHeatmap from "../../components/TimeTrackingHeatmap";

const Dashboard = () => {
  const { 
    summaryCounts, 
    topApps, 
    recentEntries, 
    membersActivity,
    screenshots,
    productivityMetrics,
    activityHeatmap,
    teamMembers 
  } = useDashboardData();
  
  const topFiveApps = Array.isArray(topApps) ? topApps.slice(0, 5) : [];

  const currentDate = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-text">
          <h1 className="dashboard-title">Employee Monitoring Dashboard</h1>
          <p className="dashboard-subtitle">{currentDate} • Real-time monitoring & analytics</p>
        </div>
      </div>

      {/* Row 1: Summary Cards - 4 in one row, NO container */}
      <div className="summary-cards-row">
        <SummaryCards summary={summaryCounts} />
      </div>

      {/* Row 2: Top Applications & Productivity Analysis */}
      <div className="dashboard-grid-row">
        {/* Top Applications Card */}
        <div className="dashboard-card">
          <div className="card-header">
            <h3 className="card-title">
              <i className="bx bx-pie-chart-alt-2 card-title-icon"></i>
              Top Applications
            </h3>
          </div>
          <div className="card-body">
            {topFiveApps.length > 0 ? (
              <div className="chart-wrapper">
                <TopAppsPieChart apps={topFiveApps} />
              </div>
            ) : (
              <div className="empty-state">
                <i className="bx bx-bar-chart-alt"></i>
                <p>No application data available</p>
              </div>
            )}
          </div>
          <div className="card-footer">
            <div className="footer-stats">
              <div className="footer-stat-item">
                <span className="stat-label">Total Apps Tracked</span>
                <span className="stat-value">24</span>
              </div>
              <div className="footer-stat-item">
                <span className="stat-label">Avg Usage Time</span>
                <span className="stat-value">3.2h</span>
              </div>
            </div>
          </div>
        </div>

        {/* Productivity Analysis Card */}
        <div className="dashboard-card">
          <div className="card-header">
            <h3 className="card-title">
              <i className="bx bx-trending-up card-title-icon"></i>
              Productivity Analytics
            </h3>
            
          </div>
          <div className="card-body">
            <ProductivityTrendChart metrics={productivityMetrics} timeframe="weekly" />
          </div>
          <div className="card-footer">
            <div className="productivity-breakdown">
              <div className="breakdown-item">
                <div className="breakdown-indicator productive"></div>
                <div className="breakdown-details">
                  <span className="breakdown-label">Productive</span>
                  <span className="breakdown-value">72%</span>
                </div>
              </div>
              <div className="breakdown-item">
                <div className="breakdown-indicator neutral"></div>
                <div className="breakdown-details">
                  <span className="breakdown-label">Neutral</span>
                  <span className="breakdown-value">18%</span>
                </div>
              </div>
              <div className="breakdown-item">
                <div className="breakdown-indicator unproductive"></div>
                <div className="breakdown-details">
                  <span className="breakdown-label">Unproductive</span>
                  <span className="breakdown-value">10%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Row 3: Live Members Activity */}
      <div className="dashboard-card full-width">
        <div className="card-header">
          <div className="card-header-main">
            <h3 className="card-title">
              <i className="bx bx-user-check card-title-icon"></i>
              Live Members Activity
            </h3>
            <p className="card-subtitle">Real-time updates of team members</p>
          </div>
          <span className="live-indicator">
            <span className="live-dot"></span>
            UPDATING EVERY 5 SECONDS
          </span>
        </div>
        <div className="card-body">
          <MembersLiveChart membersActivity={membersActivity} />
        </div>
      </div>

      {/* Row 4: Time Tracking Heatmap */}
      <div className="dashboard-card full-width">
        <div className="card-header">
          <div className="card-header-main">
            <h3 className="card-title">
              <i className="bx bx-calendar-heart card-title-icon"></i>
              Activity Heatmap
            </h3>
            <p className="card-subtitle">Weekly activity patterns</p>
          </div>
          
        </div>
        <div className="card-body">
          <TimeTrackingHeatmap userActivity={activityHeatmap} />
        </div>
      </div>

      {/* Row 5: Screenshots Gallery */}
      <div className="dashboard-card full-width">
        <div className="card-header">
          <div className="card-header-main">
            <h3 className="card-title">
              <i className="bx bx-camera card-title-icon"></i>
              Recent Screenshots
            </h3>
          </div>
          <div className="card-header-actions">
            
          </div>
        </div>
        <div className="card-body">
          <ScreenshotsGallery screenshots={screenshots} teamMembers={teamMembers} />
        </div>
      </div>

      {/* Row 6: Recent Activity Table */}
      <div className="dashboard-card full-width">
        <div className="card-header">
          <div className="card-header-main">
            <h3 className="card-title">
              <i className="bx bx-history card-title-icon"></i>
              Recent Team Activity
            </h3>
            <div className="activity-stats">
              <span className="activity-count">{recentEntries?.length || 0}</span>
              <span className="activity-label">activities today</span>
            </div>
          </div>
          <div className="card-header-actions">
            
        
          </div>
        </div>
        <div className="card-body no-padding">
          <div className="table-container">
            <TeamActivityTable entries={recentEntries} />
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Dashboard;